var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.show))?_c('es-popup',{class:[_vm.$attrs["custom-class"]],attrs:{"show":(_vm.show),"position":(_vm.position)},on:{"close":_vm.close}},[_c('div',{staticClass:"drawer-container"},[_vm._t("header"),_c('div',{staticClass:"drawer-main custom-main"},[_vm._t("default")],2)],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }